import { FC } from 'react';

import StatusDot from '@components/StatusDot/StatusDot';
import { TSupplementResponseStatus } from '@interfaces/supplements';
import useSupplementResponseStatusById from '@store/hooks/useSupplementResponseStatusById';

import { ISupplementResponseStatusDotProps } from './SupplementResponseStatusDot.interface';
import { getStatusIcon } from './utils';

const SupplementResponseStatusDot: FC<ISupplementResponseStatusDotProps> = ({
  className,
  value,
}) => {
  const supplementResponseStatus = useSupplementResponseStatusById(value);

  if (!supplementResponseStatus || supplementResponseStatus.id === TSupplementResponseStatus.None)
    return null;

  return (
    <StatusDot
      className={className}
      icon={getStatusIcon(value)}
      title={supplementResponseStatus.name}
    />
  );
};

export default SupplementResponseStatusDot;
